/**
 * wtshuang@cs.uw.edu
 * 2018/04/23
 * The class for the questions
 */
import { Token, Performance } from './Interfaces';

export class Question {
    public qid: string; // question id
    public aid: number; // article id
    public pid: number; // paragraph id
    public doc: Token[]; // the actual data
    public attention: number[][];
    public perform: Performance<number>;

    constructor (qid: string, aid: number, pid: number, doc: Token[], attention: number[][], perform: Performance<number>) {
        this.qid = qid;
        this.aid = aid;
        this.pid = pid;
        this.doc = doc;
        this.attention = attention;
        this.perform = perform;
    }

    /**
     * Make the instances into raw text
     * @return plain text of the instance.
     */
    public textize(): string {
        let text: string = '';
        this.doc.forEach((d: Token) => { text += d.text + d.whitespace; });
        return text;
    }
}


// WEBPACK FOOTER //
// ./src/stores/Question.ts